import { Component, Input, OnInit, ViewChild } from '@angular/core';

import { FILE_UPLOAD_GENERIC_ERROR } from '../../constants/status-responses.constant';
import { ActionModalComponent } from '../action-modal/action-modal.component';
import { ActionModalButton } from '../action-modal/action-modal.interface';

@Component({
    selector: 'mapp-error-status-modal',
    templateUrl: './error-status-modal.component.html',
    standalone: false,
})
export class ErrorStatusModalComponent implements OnInit {
    @Input() title: string;

    @Input() description: string;

    @ViewChild(ActionModalComponent) protected modal!: ActionModalComponent;

    protected primaryButtonObject: ActionModalButton = {
        label: 'Ok',
        action: () => this.close(),
    };

    /**
     *
     */
    ngOnInit(): void {
        if (!this.title) {
            this.title = FILE_UPLOAD_GENERIC_ERROR.title;
        }

        if (!this.description) {
            this.description = FILE_UPLOAD_GENERIC_ERROR.description;
        }
    }

    /**
     *
     */
    open(): void {
        this.modal.open();
    }

    /**
     *
     */
    close(): void {
        this.modal.close();
    }
}
